import { storeToRefs } from 'pinia';
import type { TranslatedValue } from '@/widgets/Wizard/models/wizard';
import { useMetadataStore } from '@/widgets/Wizard/stores/metadata';

export function translate(translations: TranslatedValue, locale: string): string | null {
    const translation = translations[locale];

    if (!translation) {
        return null;
    }

    return translation;
}

export function accessTranslation(key: string): string | null {
    switch (key) {
        case 'account.website': {
            const { activeAccount } = storeToRefs(useMetadataStore());

            if (!activeAccount.value) {
                return null;
            }

            return activeAccount.value.information.website;
        }

        case 'account.phoneNumber': {
            const { activeAccount } = storeToRefs(useMetadataStore());

            if (!activeAccount.value) {
                return null;
            }

            return activeAccount.value.information.phoneNumber;
        }

    }

    return null;
}
